import React, { useEffect, useState, isValidElement } from 'react';
import Alert from '@jbhi-fi/lanyard-ui/components/Alert';
import { styles } from './PerksInfo.css';
import { checkPerksSignupResult, setPerksWasCollectionRedirected, wasPerksPageflyPageViewed } from './utils';
import { useCustomerContext } from '@jbhi-fi/components/src/context/CustomerContextProvider';
import { NEW_MEMBER_SIGNUP, PREVIOUS_MEMBER_SIGNUP } from './constants';
import { POSSIBLE_ALERTS } from '../customers/components/alerts/PossibleAlerts';

export const PerksInfo = (): JSX.Element | null => {
  const [shouldDisplayPerksAlert, setShouldDisplayPerksAlert] = useState(false);
  const [wasPreviousMember, setWasPreviousMember] = useState(false);
  const [signupError, setSignupError] = useState<string | null>(null);
  const [wasClosed, setWasClosed] = useState(false);
  const { isLoggedIn, customerName } = useCustomerContext();
  const isAccountOrPerksPage = window.location.pathname === '/account' || window.location.pathname === '/pages/perks';
  const isCollectionPage = window.location.pathname.includes('/collections');
  useEffect(() => {
    if (!isCollectionPage) setPerksWasCollectionRedirected(false);
    if (isAccountOrPerksPage) return;
    const path = window.location.pathname;
    let wasPerksPageflyPromo = false;
    if (path.includes('/pages/') && !path.includes('-perks')) {
      wasPerksPageflyPromo = wasPerksPageflyPageViewed();
    }
    const perksSignupResult = checkPerksSignupResult(wasPerksPageflyPromo);
    if (perksSignupResult) {
      if (perksSignupResult === PREVIOUS_MEMBER_SIGNUP) {
        setWasPreviousMember(true);
        setShouldDisplayPerksAlert(true);
      } else if (perksSignupResult === NEW_MEMBER_SIGNUP) {
        setShouldDisplayPerksAlert(true);
      } else {
        setShouldDisplayPerksAlert(true);
        setSignupError(perksSignupResult);
      }
    }
  }, []);

  const newMemberMessage = window.Jbhifi?.perksMessaging?.newMember || '';
  const existingMemberMessage = window.Jbhifi?.perksMessaging?.existingMember || '';

  const errorComponent = signupError ? POSSIBLE_ALERTS[signupError] : null;

  if (isAccountOrPerksPage || !isLoggedIn || wasClosed || !shouldDisplayPerksAlert) return null;
  return (
    <div className={styles.container}>
      {signupError ? (
        isValidElement(errorComponent) ? (
          errorComponent
        ) : (
          <Alert type={errorComponent?.type ?? 'info'} {...errorComponent} />
        )
      ) : (
        <Alert
          closable
          type="success"
          heading={`Welcome${wasPreviousMember ? ' back' : ''} to Perks, ${customerName}!`}
          content={wasPreviousMember ? existingMemberMessage : newMemberMessage}
          onClose={() => setWasClosed(true)}
        />
      )}
    </div>
  );
};
